import React, {useState} from 'react'
import PropTypes from 'prop-types'

import {FormRadios} from '../../../01-Atoms/FormRadios/FormRadios'
import {FormSelect} from "../../../01-Atoms/FormSelect/FormSelect";
import {FormInput} from "../../../01-Atoms/FormInput/FormInput";
import {FormCheckbox} from "../../../01-Atoms/FormCheckbox/FormCheckbox";
import {AddressLookUp} from "../../../02-Molecules/AddressLookUp/AddressLookUp";


/**
 * SectionBankDetails component
 */
export const StepTwo = ({accountHolder, accountNumber, accountSortCode, billingAddressLine1, billingAddressLine2, billingAddressTownCity, billingAddressPostCode, loqateKey, paymentStartDate, paymentDates, onInputChange, useContactAddress, validationHash, ...props}) => {
  const [paymentDateEditMode, paymentDateEditModeSet] = useState(false)

  return (
    <div className={'o-section-bank-details'}>
      {paymentDateEditMode ?
        <div className={'o-section-bank-details__start-date'}>
          <FormSelect
            label={'Please select the date of your first payment'}
            value={paymentStartDate}
            required={true}
            name={'payment_start_date'}
            onInputChange={onInputChange}
            validationHash={validationHash}
            options={paymentDates.map(paymentDate => {return {value: paymentDate, label: paymentDate}})}
          />

        </div> :
        <div className={'o-section-bank-details__start-date b-form-row'}>
          Your first payment will be <strong>{paymentStartDate}</strong>
          <div>
            <button className={'b-button-text-blue'} onClick={() => paymentDateEditModeSet(true)}>change payment date</button>
          </div>
        </div>
      }

      <FormInput
        label={'Name of account holder'}
        value={accountHolder}
        required={true}
        name={'account_holder'}
        type={'text'}
        onInputChange={onInputChange}
        validationHash={validationHash}
        validationMessages={
          [
            { type: 'valueMissing', message: 'Please provide the account holder\'s name' }
          ]
        }
      />

      <FormInput
        label={'Account Number'}
        value={accountNumber}
        required={true}
        name={'account_number'}
        type={'number'}
        onInputChange={onInputChange}
        validationHash={validationHash}
        validationMessages={
          [
            { type: 'valueMissing', message: 'Please provide the account number' }
          ]
        }
      />

      <FormInput
        label={'Sort code'}
        placeholder={'00-00-00'}
        value={accountSortCode}
        required={true}
        name={'account_sort_code'}
        type={'text'}
        onInputChange={onInputChange}
        validationHash={validationHash}
        validationMessages={
          [
            { type: 'valueMissing', message: 'Please provide the sort code' }
          ]
        }
      />

      <FormCheckbox
        checked={useContactAddress}
        label={'Use contact address'}
        name={'use_contact_address'}
        onInputChange={onInputChange}
      />

      {!useContactAddress &&
      <AddressLookUp
        loqateKey={loqateKey}
        legend={'Billing address'}
        names={{
          addressLine1: 'billing_address_line_1',
          addressLine2: 'billing_address_line_2',
          townCity    : 'billing_address_town_city',
          postCode    : 'billing_address_post_code',
        }}
        showLookup={true}
        onInputChange={onInputChange}
        validationHash={validationHash}
        values={{
          addressLine1: billingAddressLine1,
          addressLine2: billingAddressLine2,
          townCity    : billingAddressTownCity,
          postCode    : billingAddressPostCode,
        }}/>
      }

      <div>
        <button className={'b-button-text-blue'} onClick={() => props.onBack(0)}>back</button>
      </div>
    </div>
  )
}

/**
 * StepOne PropType
 */
StepTwo.propTypes = {
  accountHolder         : PropTypes.string,
  accountNumber         : PropTypes.string,
  accountSortCode       : PropTypes.string,
  billingAddressLine1   : PropTypes.string,
  billingAddressLine2   : PropTypes.string,
  billingAddressTownCity: PropTypes.string,
  billingAddressPostCode: PropTypes.string,
  loqateKey             : PropTypes.string,
  paymentStartDate      : PropTypes.string,
  paymentDates          : PropTypes.array,
  onInputChange         : PropTypes.func,
  useContactAddress     : PropTypes.bool,
  validationHash        : PropTypes.string,
}
